'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React, { type ReactNode, useState } from 'react';
import { QueryDevtoolsProvider } from './query-devtools-provider';

type QueryProviderProps = {
  children: ReactNode;
};

const QueryProvider = ({ children }: QueryProviderProps): React.JSX.Element => {
  const [queryClient] = useState(() => new QueryClient({
    defaultOptions: {
      queries: {
        // Server-rendered QueryClients must not retain request state through finite GC timers.
        gcTime: typeof window === 'undefined' ? Infinity : 10 * 60 * 1000,
        retry: 1,
        staleTime: 5 * 60 * 1000,
      },
    },
  }));

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      <QueryDevtoolsProvider />
    </QueryClientProvider>
  );
};

export default QueryProvider;
